import apiCall from 'apps/investcore/apiCalls/stock-products';
import { DynamicFilterForm } from 'common/dynamic-filter-form';
import { DetailPage, EditPage, ListPage } from 'common/ui/admin-CRUD/page';
import { columnsGenerator } from './config';
import ItemDetail from './detail';
import ItemForm from './edit-form';

export const StockProductListPage = () => (
  <ListPage
    title="All Stock Products"
    apiCall={apiCall}
    columnsGenerator={columnsGenerator}
    FilterForm={DynamicFilterForm}
  />
);

export const StockProductEditPage = props => (
  <EditPage
    title="Edit Stock Product"
    apiCall={apiCall}
    listUrl={`/admin/products/stocks`}
    ItemForm={ItemForm}
    resourceName="data"
    {...props}
  />
);

export const StockProductDetailPage = props => (
  <DetailPage
    title="Stock Product"
    apiCall={apiCall}
    listUrl={`/admin/products/stocks`}
    ItemDetail={ItemDetail}
    resourceName="data"
    options={{ editEnabled: true }}
    {...props}
  />
);
